import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal';

export default function updateTickets(rb: RequestBuilder, entity: string, multiSelect: MultiSelect): Promise<any> {
	return new Promise<any>(resolve => {
		openModal('MultiUpdateTicket', {
			filters: rb,
			entity,
			multiSelect,
			onClose: resolve
		});
	});
}
